<template>
    <div>
        <courseorder></courseorder>
    </div>
</template>

<script>
import courseorder from '../../components/courseOrder'
export default {
    components:{
        courseorder
    },
    data(){
        return {
        };
    },
    mounted (){
    },
    methods: {
    }
}
</script>

<style scoped>
.icon{
    position: absolute;
    top: 15px;
    left: 16px;
}
.van-tabs /deep/ .van-tabs__wrap {
  height: 36px;
  margin: 0 70px;
  background-color: #fff;
}
.van-tabs /deep/ .van-tabs__line {
  background-color: #3296fa;
  height: 2px;
}
.list{
    padding-top: 15px;
}
.zhibo{
    width: 345px;
    border-radius: 4px;
    border: 1px solid #000;
    padding: 8px;
    margin:0 auto 10px;
}
.kemu{
    width: 39px;
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.14);
    text-align: center;
    border: 1px solid rgba(187, 187, 187, 1);
    padding: 2px;
}
.kemu_title{
    width: 64px;
    height: 24px;
    margin-left: 3px;
    color: rgba(16, 16, 16, 1);
    font-size: 16px;
    font-weight: 700;
}
.class_time{
    line-height: 30px;
    font-size: 12px;
}
.fff{
    display: flex;
    justify-content: space-between;
}
.img{
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background-color: #000;
    display: inline-block;
}
.img img{
    visibility: middle;
}
.teacher{
    line-height: 28px;
    font-size: 14px;
}
.money{
    color: rgba(244, 21, 33, 1);
    font-size: 18px;
    text-decoration: none;
    margin-left: 3px;
}
.money span{
    font-size: 12px;
    color: rgba(16, 16, 16, 0.36);
    text-decoration:line-through;
    margin-right: 3px;
}
</style>


// WEBPACK FOOTER //
// src/pages/courseOrder/courseOrder.vue